import React from 'react';
import { Router, Route } from 'react-router-dom';
import OuterContainer from './components/outer-container';
import createBrowserHistory from './history';
import GoogleContainer from './components/google-container';

export interface AppProps {
}

export interface AppState {
}

export default class App extends React.Component <AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
  }

  render() {
    return (
      <Router history={createBrowserHistory}>
        
          <Route path='/' exact component={OuterContainer} />
          <Route path='/:id' exact component={OuterContainer} />
          <Route path='/doc/' exact component={GoogleContainer} />
          <Route path='/doc/:id' exact component={GoogleContainer} />

      </Router>
    );
  }
}
